import { render, staticRenderFns } from "./ModuleContact.vue?vue&type=template&id=748afa01&scoped=true&"
import script from "./ModuleContact.vue?vue&type=script&lang=js&"
export * from "./ModuleContact.vue?vue&type=script&lang=js&"
import style0 from "./ModuleContact.vue?vue&type=style&index=0&id=748afa01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748afa01",
  null
  
)

export default component.exports